import { colorsAlpha } from "./colors/colorsAlpha";
import { colorsBackground } from "./colors/colorsBackground";
import { colorsBorder } from "./colors/colorsBorder";
import { colorsForeground } from "./colors/colorsForeground";
import { colorsPrimitive } from "./colors/colorsPrimitive";
import { colorsShadows } from "./colors/colorsShadows";
import { colorsText } from "./colors/colorsText";
import { colorsUtility } from "./colors/colorsUtility";
import { radius } from "./spacing/radius";
import { spacing } from "./spacing/spacing";
import { spacingWidth } from "./spacing/spacingWidth";
import { typography } from "./typography/typography";

export const useThemeToken = () => {
	const getColors = () => ({
		...colorsPrimitive,
		...colorsUtility,
		...colorsText,
		...colorsForeground,
		...colorsBorder,
		...colorsBackground,
		...colorsAlpha,
		...colorsShadows,
	});

	const getTypography = () => ({ ...typography });
	const getSpacing = () => ({
		...spacing,
		...spacingWidth,
	});
	const getRadius = () => ({
		...radius,
	});

	return {
		colors: {
			primitive: colorsPrimitive,
			utility: colorsUtility,
			text: colorsText,
			foreground: colorsForeground,
			border: colorsBorder,
			background: colorsBackground,
			alpha: colorsAlpha,
			shadows: colorsShadows,
		},
		typography: {
			size: { ...typography.size },
			weight: { ...typography.weight },
			lineHeight: { ...typography.lineHeight },
		},
		spacing,
		spacingWidth,
		getColors: getColors(),
		getTypography: getTypography(),
		getSpacing: getSpacing(),
		getRadius: getRadius(),
	};
};
